import { SystemConfig } from '@chakra-ui/react';

import { themeRecipes } from './recipes';

export const themeConfig: SystemConfig = {
  theme: {
    ...themeRecipes,
  },
};
